import axios from "axios";
import { authConfig, endpoint } from "./http";

export async function listModerationFlags({
  accessToken,
  apiUrl,
  status,
  targetType,
}) {
  const response = await axios.get(endpoint(apiUrl, "/admin/moderation-flags"), authConfig(accessToken, {
    params: {
      status: status || undefined,
      target_type: targetType || undefined,
    },
  }));

  return response.data;
}

export async function listListingReports({ accessToken, apiUrl, status }) {
  const response = await axios.get(endpoint(apiUrl, "/admin/reports/listings"), authConfig(accessToken, {
    params: {
      status: status || undefined,
    },
  }));

  return response.data;
}

export async function updateListingReportStatus({
  accessToken,
  apiUrl,
  reportId,
  status,
}) {
  const response = await axios.patch(
    endpoint(apiUrl, `/admin/reports/listings/${reportId}`),
    { status },
    authConfig(accessToken)
  );

  return response.data;
}

export async function listMessageReports({ accessToken, apiUrl, status }) {
  const response = await axios.get(endpoint(apiUrl, "/admin/reports/messages"), authConfig(accessToken, {
    params: {
      status: status || undefined,
    },
  }));

  return response.data;
}

export async function updateMessageReportStatus({
  accessToken,
  apiUrl,
  reportId,
  status,
}) {
  const response = await axios.patch(
    endpoint(apiUrl, `/admin/reports/messages/${reportId}`),
    { status },
    authConfig(accessToken)
  );

  return response.data;
}

export async function updateModerationFlagStatus({
  accessToken,
  apiUrl,
  flagId,
  status,
}) {
  const response = await axios.patch(
    endpoint(apiUrl, `/admin/moderation-flags/${flagId}`),
    { status },
    authConfig(accessToken)
  );

  return response.data;
}
